module.exports = __webpack_public_path__ + "img/thumb_05.29e11cc8.jpg";